import * as React from 'react';

import _ from 'lodash';
import ChannelTabs from './channelTab';
import ChannelList from './channelList';
import PropTypes from 'prop-types';

const propTypes = {
  Channels: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  select: PropTypes.oneOfType([
    PropTypes.shape({
      _id: PropTypes.string,
    }),
    PropTypes.object,
  ]),
  tokenCheck: PropTypes.func,
  onClick: PropTypes.func,
  onClickVOD: PropTypes.func,
  onClickEPG: PropTypes.func,
};

const defaultProps = {
  Channels: {
    type: '',
    list: {},
  },
  tokenCheck: null,
  select: null,
  onClick: null,
  onClickVOD: null,
  onClickEPG: null,
};

function getTabIndex({ list }, selectChannel) {
  if (selectChannel === null || selectChannel === undefined) {
    return -1;
  }

  const index = _.findIndex(list, groups => {
    const findObj = groups.list.find(
      channel => channel._id === selectChannel._id,
    );
    if (findObj !== undefined) {
      return true;
    }
    return false;
  });
  return index;
}

class ChannelContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    const { Channels, select } = props;
    this.state = {
      tabIndex: getTabIndex(Channels, select),
    };
    this.handlerChannelSelect = this.handlerChannelSelect.bind(this);
    this.handlerEPGSelect = this.handlerEPGSelect.bind(this);
    this.handlerTabSelect = this.handlerTabSelect.bind(this);
  }

  findById(id) {
    return this.props.Channels.list[this.state.tabIndex].list.find(
      obj => obj._id === id,
    );
  }

  // 지대지, bs, cs로 바꾼다.
  handlerTabSelect(tabIndex) {
    const chGroup = this.props.Channels.list[tabIndex];
    if (chGroup.link !== undefined) {
      window.location.href = chGroup.link;
    } else {
      if (tabIndex !== 1) {
        this.setState({ tabIndex });
      }
      this.props.onClickVOD(chGroup.group_title)
    }
  }

  // player.jsx << handlerChannelSelect
  handlerChannelSelect(id, url) {
    if (typeof this.props.onClick === 'function') {
      this.props.tokenCheck();
      this.props.onClick(this.findById(id), url);
    }
  }

  // player.jsx << handlerEPGSelect
  handlerEPGSelect(id, epgNumber) {
    if (typeof this.props.onClickEPG === 'function') {
      this.props.onClickEPG(this.findById(id), epgNumber);
    }
  }

  render() {
    const { Channels, select } = this.props;
    const { tabIndex } = this.state;

    const chGroup = Channels.list[tabIndex];
    const isVOD = chGroup.group_title === 'VOD'
    if (chGroup === undefined) {
      return null;
    }
    // height: fit-content
    return (
      <div id="ch-container">
        <ChannelTabs
          list={Channels.list}
          select={tabIndex}
          onClick={this.handlerTabSelect}
        />
        {!isVOD && (
          <ChannelList
            {...chGroup}
            select={select}
            onClick={this.handlerChannelSelect}
            onClickEPG={this.handlerEPGSelect}
          />
        )}
      </div>
    );
  }
}

ChannelContainer.propTypes = propTypes;
ChannelContainer.defaultProps = defaultProps;

export default ChannelContainer;
